import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import "./CTA.css";

const CTA = () => {
  const [contentRef, contentVisible] = useScrollAnimation();

  const handleButtonClick = () => {
    window.open(
      "https://calendly.com/bsquarefinancial-info/1-on-1-bsquare-15-minute-cash-flow-audit",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <section className="cta" id="book-consultation">
      <div className="cta-container">
        <div ref={contentRef} className={`cta-content ${contentVisible ? "animate-in" : ""}`}>
          <div className="cta-text-wrapper">
            <h2 className="cta-headline">Get Started</h2>
            <p className="cta-description">
              Every engagement begins with understanding your situation and priorities. A confidential consultation
              allows us to determine whether there is meaningful value we can add.
            </p>
            <button className="cta-button" onClick={handleButtonClick}>
              Book a Confidential Consultation
              <span className="cta-button-icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4 12L12 4M12 4H6M12 4V10"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
